import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as FamiliaCrud from 'services/familia.service'

const FamiliaFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  values,
  setValues,
  handleChange
}) => {
  const [familias, setFamilias] = React.useState([])

  React.useEffect(() => {
    FamiliaCrud.getFamilias_Select().then(({ data }) => {
        setFamilias(data)})
  }, [])

  const familiaChangeHandler = React.useCallback(
    e => {
      handleChange(e)
      values._idFamilia = e.target.value
      setValues(values)
    },
    [values, setValues, handleChange]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='FAMILIA' htmlFor='select-familia' md={5} alignRightAt='md' />
        <Col md={7}>
          <Form.InputGroup>
            <Field name='_idFamilia'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  onChange={familiaChangeHandler}
                  id='select-familia'
                >
                  <option value=''>Seleccionar</option>
                  {familias &&
                    familias.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(FamiliaFormGroup)
